var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.failure)?_c('div',{staticClass:"booking-link-failure",attrs:{"data-test":"booking-link-failure","role":"alert"}},[_vm._v(_vm._s(_vm.failureMessage))]):_c('div',[_vm._v("Now redirecting you...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }